export const color = {
    '100': '#3FDC2B',
    '121': '#3FDC2B',
    '110': '#3FDC2B',
    '200': '#FFCA64',
    '210': '#FFCA64',
    '300': '#FFCA64',
    '710': '#FFCA64',
    '720': '#FFCA64',
    '730': '#FFCA64',
    '740': '#FFCA64',
    '750': '#FFCA64',
    '400': '#BBBBBB',
    '500': '#BBBBBB',
    '600': '#BBBBBB',
    '1000': '#C95D63',
};
// 时间格式化
export const getTime = (date) => {
  let h = Math.floor(date / 60 / 60)
  let m = Math.floor((date - h * 60 * 60) / 60)
  let s = date - h * 60 * 60 - m * 60
  let h1 = h < 10 ? '0' + h : h
  let m1 = m < 10 ? '0' + m : m
  let s1 = s < 10 ? '0' + s : s
  return h1 + ':' + m1 + ':' + s1
}

// 异步工作台
export const WORK_BENTH_TICKET_TYPE = 1